<template>
  <validation-observer #default="{handleSubmit}">
    <b-form @submit.prevent>
      <b-tabs v-model="tabIndex">
        <b-tab
          title="Campaign Details"
          lazy
        >
          <h4 class="text-capitalize mb-3 mt-2">
            <strong>content</strong>
          </h4>

          <campaign-design-inputs
            :campaign="campaign"
            :disabled="$attrs.disabled"
          />

          <b-row
            class="mt-3"
            align-h="between"
          >
            <b-col md="2">
              <b-button
                variant="outline-primary"
                class="btn-pill mb-1 mb-md-0 d-block d-md-inline-block"
                tag="a"
                @click="discard"
              >
                Discard
              </b-button>
            </b-col>
            <b-col
              md="2"
              class="text-right"
            >
              <b-button
                variant="primary"
                class="btn-pill d-block d-md-inline-block"
                tag="a"
                @click="handleSubmit(()=>tabIndex++)"
              >
                Continue
              </b-button>
            </b-col>
          </b-row>
        </b-tab>

        <!-- Send Tab -->
        <b-tab
          title="Send"
          lazy
        >
          <campaign-send-inputs
            :campaign="campaign"
            :disabled="$attrs.disabled"
          />

          <b-row class="mt-3">
            <b-col
              md="2"
              class="mb-1"
            >
              <b-button
                variant="primary"
                class="btn-pill d-block d-md-inline-block"
                tag="a"
                @click="tabIndex--"
              >
                Back
              </b-button>
            </b-col>

            <b-col
              v-if="!$attrs.disabled"
              class="text-right"
            >
              <submit-button
                class="mr-md-1 mb-1 mb-md-0"
                v-bind="{submit,handleSubmit,submitText:'Save as draft'}"
              />
              <submit-button
                v-if="$can('sendInvitations','campaign')"
                v-bind="{submit:sendCampaign,handleSubmit,submitText:'Send'}"
              />
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </b-form>
  </validation-observer>
</template>

<script>
import handleAlerts from '@/compositions/common/handleAlerts'
import SubmitButton from '../FormInputs/SubmitButton.vue'
import CampaignDesignInputs from './CampaignDesignInputs.vue'
import CampaignSendInputs from './CampaignSendInputs.vue'

export default {
  name: 'CampaignForm',
  components: { CampaignDesignInputs, CampaignSendInputs, SubmitButton },
  props: {
    campaign: { type: Object, default: () => {} },
    submit: { type: Function, default: () => {} },
    sendCampaign: { type: Function, default: () => {} },
  },
  data() {
    return {
      tabIndex: 0,
    }
  },
  setup() {
    const { confirmOperation } = handleAlerts()
    return { confirmOperation }
  },
  methods: {
    discard() {
      this.confirmOperation('All changes will be discarded', 'Discard').then(() => {
        this.$router.back()
      })
    },
  },
}
</script>

<style>

</style>
